import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function UserAssignmentFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={() => props.setIsOpen(false)}
            bullets={[
                'Assign leads to individuals or teams at any point in your sales process.',
                'Use round-robin distribution for fair lead sharing across team members.',
                'Create special rules to route leads based on criteria like territory, industry, or value, so leads automatically go to the right person.',
            ]}
            description='Efficiently route leads to the right team members with customizable assignment rules.'
            feature='leadUserAssignment'
            title='Set up automatic lead assignment rules'
        />
    );
}
